// Rules that only apply to the mobil editor: what has to be true before verifying / saving.
const useEditorValidation = ({
  uiContext,
  pengecekanSaved,
  saveCekDetil,
  saveDetilMany
}) => {
  const handleValidateKeamanan = (type) => {
    if (!pengecekanSaved["bagian_depan"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian depan belum di-save");
      return false;
    } else if (!pengecekanSaved["bagian_samping"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian samping belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_belakang"]) {
      uiContext.showErrorMsg(
        "Error",
        "Pengecekan bagian belakang belum di-save"
      );
      return false;
    } else if (!pengecekanSaved["bagian_dalam"]) {
      uiContext.showErrorMsg("Error", "Pengecekan bagian dalam belum di-save");
      return false;
    } else {
      return true;
    }
  };

  const handleOnClickSaveCheckList = ({ detils, type }) => {
    saveCekDetil({ detils, type });
  };

  const handleOnClickSaveMarkingList = async ({
    type,
    labelGrup,
    pengecekanDetilData,
  }) => {
    saveDetilMany({ type, labelGrup, pengecekanDetilData });
  };

  return {
    handleValidateKeamanan,
    handleOnClickSaveCheckList,
    handleOnClickSaveMarkingList
  };
};

export default useEditorValidation;
